/*
 * Proprietary and confidential | 2026 | SoundTalks NV
 */

const prefix = (type) => `st/admin/alertExplain/${type}`;

export const OVERVIEW_LOAD_START = prefix('OVERVIEW_LOAD_START');
export const OVERVIEW_LOAD_SUCCESS = prefix('OVERVIEW_LOAD_SUCCESS');
export const OVERVIEW_LOAD_FAILED = prefix('OVERVIEW_LOAD_FAILED');

export const HEATMAP_LOAD_START = prefix('HEATMAP_LOAD_START');
export const HEATMAP_LOAD_SUCCESS = prefix('HEATMAP_LOAD_SUCCESS');
export const HEATMAP_LOAD_FAILED = prefix('HEATMAP_LOAD_FAILED');

export const ALERTS_LOAD_START = prefix('ALERTS_LOAD_START');
export const ALERTS_LOAD_SUCCESS = prefix('ALERTS_LOAD_SUCCESS');
export const ALERTS_LOAD_FAILED = prefix('ALERTS_LOAD_FAILED');

export const RULES_LOAD_START = prefix('RULES_LOAD_START');
export const RULES_LOAD_SUCCESS = prefix('RULES_LOAD_SUCCESS');
export const RULES_LOAD_FAILED = prefix('RULES_LOAD_FAILED');

export const CLEAR = prefix('CLEAR');
export const CLEAR_DRILLDOWN = prefix('CLEAR_DRILLDOWN');
